import React, { createContext, useContext, useEffect, useState } from 'react';

import useFetchWithToken from '../../hooks/useFetchWithToken';
import { SECRETS_API_URL } from '../../utils/environmentVariables';

type Secrets = {
  amchartsLicenseKey: string;
};

const SecretsContext = createContext<{
  getSecrets: () => Secrets;
}>({
  getSecrets: () => {
    return {
      amchartsLicenseKey: '',
    };
  },
});

export const useSecrets = () => useContext(SecretsContext);

type SecretsProviderProps = {
  children: React.ReactNode;
};

export const SecretsProvider = ({ children }: SecretsProviderProps) => {
  const { fetchDataWithToken } = useFetchWithToken();
  const [secrets, setSecrets] = useState({
    amchartsLicenseKey: '',
  });

  useEffect(() => {
    fetchDataWithToken<Secrets>(SECRETS_API_URL, (secretsResponse) => setSecrets(secretsResponse));
  }, []);

  const getSecrets = () => {
    return secrets;
  };

  return (
    <SecretsContext.Provider value={{ getSecrets: getSecrets }}>{children}</SecretsContext.Provider>
  );
};
